module.exports = __webpack_public_path__ + "img/logo-2.e14deeaf.png";